import { BIG_QUERY } from '../eventName';
import buildBigQueryEmitter from '../../tools/bigQuery/emitter';

/**
 * Sends events to BigQuery.
 * Each event should respect our raw events bigQuery schema:
 * https://bigquery.cloud.google.com/table/fiverr-bigquery:raw.events
 *
 * @example
 *
 * bigQuery.send({
 *   type: 'event1'
 * }, {
 *   type: 'event2'
 * });
 */
const send = buildBigQueryEmitter(BIG_QUERY);

export default { send };
